/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Billing_Board_Paid_SubInputs */



/**
* | output |
* | --- |
* | "Payment confirmed · {count} invoices" |
*
* @param {Partner_Billing_Board_Paid_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_paid_sub = /** @type {((inputs: Partner_Billing_Board_Paid_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Paid_SubInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zahlung bestätigt · ${i?.count} Rechnungen`)
	return /** @type {LocalizedString} */ (`Payment confirmed · ${i?.count} invoices`)
});